import { ScrollText } from "lucide-react";
import PolicyDialog from "./PolicyDialog";

/**
 * HouseRulesDialog — thin wrapper over PolicyDialog, kept for backwards-compat and
 * because the trigger styling is specifically tuned for the property page button bar.
 */
export default function HouseRulesDialog({ propertyName, slug, html, variant = "pill" }) {
  let trigger;
  if (variant === "pill") {
    trigger = (
      <button
        type="button"
        data-testid={`house-rules-trigger-${slug}`}
        className="inline-flex items-center gap-1.5 rounded-full border border-forest/20 bg-mist/40 px-3 py-1.5 text-xs font-medium text-forest transition hover:bg-mist"
      >
        <ScrollText size={13} /> House rules
      </button>
    );
  } else if (variant === "prominent") {
    trigger = (
      <button
        type="button"
        data-testid={`house-rules-trigger-${slug}`}
        className="inline-flex items-center gap-2 rounded-full border border-forest/20 bg-white px-4 py-2 text-sm font-medium text-forest shadow-card transition hover:bg-mist/40"
      >
        <ScrollText size={14} /> Read the house rules
      </button>
    );
  } else {
    // inline — appears as a text link within a sentence (for consent rows etc.)
    trigger = (
      <button
        type="button"
        data-testid={`house-rules-trigger-${slug}`}
        className="underline underline-offset-2 text-forest hover:text-gold font-medium"
      >
        House rules
      </button>
    );
  }

  return (
    <PolicyDialog
      trigger={trigger}
      title="House rules"
      subtitle={propertyName}
      html={html}
      testId={`house-rules-${slug || "default"}`}
      emptyFallback={(
        <>
          <p className="text-noir/60">
            Stay-specific house rules will appear here. Our hospitality team will share the full
            guide once your booking is confirmed, and you can always message us beforehand for
            anything specific — quiet hours, pet policy, parking, shoot usage, etc.
          </p>
          <p className="text-noir/60">
            Planning a private gathering or shoot? Let us know during booking so we can confirm
            what&apos;s possible at this property.
          </p>
        </>
      )}
    />
  );
}
